module.exports = __webpack_public_path__ + "img/elo.e26726d7.png";